export default class TutorialFinger extends PIXI.Container {

    constructor() {
        super();

        this._tweens = new P3.utils.TWEEN.Group();

        this._finger = new PIXI.Sprite(P3.assets.texture("cursor"));
        this._finger.y = -30;
        this.addChild(this._finger);
    }

    animate() {
        new P3.utils.TWEEN.Tween(this._finger, this._tweens)
            .to({y: 60}, 820)
            .yoyo(true)
            .repeat(Infinity)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    update() {
        this._tweens.update();
    }

}